import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  withTheme,
  Theme,
} from '@material-ui/core';
import { localisation } from '../../../i18n/LanguageService';
import styles from './EmptyUserPlaylistDialog.module.css';
import autobind from 'autobind-decorator';
import { Session } from 'inspector';
import NoDataIllustration from '../../illustrations/NoDataIllustration';

export interface EmptyUserPlaylistDialogProps {
  open: boolean;
  theme?: Theme;
  onClose: (leave: boolean) => void;
}

export interface EmptyUserPlaylistDialogState {}

class EmptyUserPlaylistDialog extends React.Component<EmptyUserPlaylistDialogProps, EmptyUserPlaylistDialogState> {
  constructor(props: EmptyUserPlaylistDialogProps) {
    super(props);
  }

  @autobind
  handleCloseConfirm() {
    this.props.onClose(true);
  }

  @autobind
  handleCloseCancel() {
    this.props.onClose(false);
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCloseCancel}
        aria-labelledby="form-dialog-title"
      >
        <NoDataIllustration color={this.props.theme!.palette.primary.main} className={styles.emptyIllustration} />
        <DialogTitle id="form-dialog-title">
          {localisation.strings.userPlaylistEmptyPlaylistDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{localisation.strings.userPlaylistEmptyPlaylistDialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button onClick={this.handleCloseCancel} color="primary">
            {localisation.strings.userPlaylistEmptyPlaylistDialogCancel}
          </Button>
          <Button onClick={this.handleCloseConfirm} color="primary">
            {localisation.strings.userPlaylistEmptyPlaylistDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTheme(EmptyUserPlaylistDialog);
